import React from 'react';
import PropTypes from 'prop-types';
import pure from 'recompose/pure';
import {POS_USER_TYPES as UserTypeList} from '../User/posUserLists';

/**
 * A function that displays a TextField with POS User Type name instead of ID.
 *
 * @param source
 * @param record
 * @param elStyle
 * @return {*}
 * @constructor
 */
const POSUserTypeNameTextField = ({ source, record = {}, elStyle }) => {
    let level = record[source];
    let typeName = UserTypeList.find(levelItem => parseInt(levelItem.level, 10) === level);
    if (!typeName) {
        typeName = {name: level};
    }
    return <span style={elStyle}>{typeName.name}</span>;
};

POSUserTypeNameTextField.propTypes = {
    addLabel: PropTypes.bool,
    elStyle: PropTypes.object,
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

const PurePOSUserTypeNameTextField = pure(POSUserTypeNameTextField);

PurePOSUserTypeNameTextField.defaultProps = {
    addLabel: true,
};

export default PurePOSUserTypeNameTextField;



// WEBPACK FOOTER //
// ./src/Fuse/components/POSUserTypeNameTextField.js